import { render, staticRenderFns } from "./tasks-modal-list-item.vue?vue&type=template&id=c5830142"
import script from "./tasks-modal-list-item.vue?vue&type=script&lang=js"
export * from "./tasks-modal-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports